module.exports = __webpack_public_path__ + "static/media/room3_1.57e51cde.JPG";